module.exports = require("d3-scale");


/*****************
 ** WEBPACK FOOTER
 ** external "d3-scale"
 ** module id = 97
 ** module chunks = 0 1
 **/